import { apiClient } from '@app/lib'
import { type SugarEnrollmentParams, type SugarEnrollmentsPaginatedResponse } from '@app/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const useEnrollments = (page: number = 1, filters: SugarEnrollmentParams = {}) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    placeholderData: keepPreviousData,
    queryKey: ['enrollments', filters, page],
    queryFn: async () => {
      const { data } = await apiClient.get<SugarEnrollmentsPaginatedResponse>('/api/enrollments', {
        params: {
          ...filters,
          page: Math.max(1, page),
          limit: 25
        }
      })

      return data
    }
  })
}
